<!--整体布局-->
<template>
  <div class="all-buju fs18 bbox" style="background-color: #131317">
    <div class="all-head-box flex ac jb" style="border-bottom-color: #303346">
      <img
        :src="head_logo"
        class="head_logo cr"
        alt="indexIcon"
        @click="handleJump2()"
      />
      <div class="popover-box flex ac">
        <!-- 移动端查看 -->
        <el-popover
          ref="popoverRef3"
          v-model="popoverVisible3"
          placement="bottom-end"
          trigger="hover"
          width="150"
        >
          <template>
            <div class="er-wei-box cr">
              <p>打开微信扫描下方二维码</p>
              <img :src="qrcode" alt="" />
            </div>
          </template>
          <template slot="reference">
            <div class="flex ac newboder">
              <img
                class="icon-point-img"
                :src="`编组5.png` | fullImageUrl"
                alt="icon1"
              />
              <div class="newtitle">移动端查看</div>
            </div>
          </template>
        </el-popover>
        <!-- 消息通知 -->
        <el-popover
          ref="newpopoverVisible1"
          v-model="newpopoverVisible1"
          placement="bottom-end"
          trigger="hover"
          width="624"
        >
          <template>
            <div class="notice-box cr">
              <div class="flex ac jb">
                <div class="notice-left">
                  <div class="every-notice1">消息中心</div>
                  <div
                    v-for="(item, index) in noticeList"
                    :key="index"
                    class="every-notice"
                  >
                    <div class="notice-item">
                      <div class="notice-item-title te">{{ item.title }}</div>
                      <div
                        v-if="activeNoticeIndex === index"
                        class="notice-item-cont"
                        v-html="content"
                      ></div>
                      <div class="flex jb item-bottom">
                        <div class="item-bottom-left">
                          {{ item.create_time }}
                        </div>
                        <div
                          class="item-bottom-rigth"
                          @click.stop="showNotice(item, index)"
                        >
                          {{ activeNoticeIndex === index ? "收起" : "展开" }}
                          <i
                            style="margin-left: 5px"
                            :class="
                              activeNoticeIndex === index
                                ? 'el-icon-arrow-up'
                                : 'el-icon-arrow-down'
                            "
                          >
                          </i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template slot="reference">
            <div class="notice-icon flex ac cr newboder">
              <img :src="`编组6.png` | fullImageUrl" alt="" />
              <div class="newtitle">通知</div>
            </div>
          </template>
        </el-popover>
        <!-- //积分，会员 -->
        <div class="flex ja ac newboder">
          <el-popover
            ref="popoverRef"
            v-model="popoverVisible"
            placement="bottom-end"
            trigger="hover"
            width="300"
          >
            <template>
              <div class="hover-pop-box cr" style="color: #e9dec2">
                <p class="bold">算力说明</p>
                <div v-html="jfContent"></div>
                <div class="flex ac jb">
                  <div class="btn1" @click="handleJump(6, '/consum')">
                    算力明细
                  </div>
                  <el-button type="primary" @click="handleDh">
                    算力兑换
                  </el-button>

                  <!-- <div class="btn2" @click="handleDh">积分兑换</div> -->
                </div>
              </div>
            </template>
            <template slot="reference">
              <div class="flex ac">
                <img
                  class="icon-point-img"
                  :src="`编组56.png` | fullImageUrl"
                  alt="icon1"
                />
                <div class="icon-point-img-txt">
                  {{ points }}
                </div>
                <!-- <p>{{ points }}</p> -->
              </div>
            </template>
          </el-popover>
          <div class="layout-divider-box">
            <el-divider direction="vertical"></el-divider>
          </div>
          <el-popover
            ref="popoverRef2"
            v-model="popoverVisible2"
            placement="bottom-end"
            trigger="hover"
            width="300px"
          >
            <template>
              <div class="hover-pop-box cr">
                <div v-if="expire_time">
                  <div class="ykt-text">已开通{{site_title}}VIP</div>
                  <div style="margin-top: 10px">
                    会员有效期至 {{ expire_time }}
                  </div>
                </div>
                <div v-else>
                  <div class="ykt-text">未开通{{site_title}}VIP</div>
                </div>
              </div>
            </template>
            <template slot="reference">
              <div class="vip-box cr">{{site_title}}VIP</div>
            </template>
          </el-popover>
        </div>

        <el-popover
          ref="popoverRef4"
          v-model="popoverVisible4"
          placement="bottom-end"
          trigger="hover"

        >
          <template>
            <div class="hover-pop-box_new cr">
              <div class="pop-userinfo">
                <div>
                  <img :src="avatar" alt="" />
                </div>
                <div class="username te">{{ username }}</div>
              </div>
              <div class="shiyongkongjian">
                <div class="">
                  已使用空间<span class="used"
                    >{{ used }}MB/{{ total_format }}G</span
                  >
                </div>
              </div>
              <!-- <div style="width: 100%">
                <el-progress :text-inside="true" :stroke-width="18" :percentage="percent"
                             status="success"></el-progress>
              </div> -->
              <div style="min-width: 222px; max-width: 222px">
                <!-- <el-progress :percentage="percent" :format="formatProgress"></el-progress> -->
                <el-progress
                  :stroke-width="18"
                  :text-inside="true"
                  :percentage="percent"
                  :color="'#F7D274'"
                  status="success"
                ></el-progress>
              </div>
              <div
                v-if="is_tourist != 1"
                @click.stop="handleKr"
                class="flex ac hover-pop-box_new_item"
              >
                <img :src="`编组37.png` | fullImageUrl" />
                <p>空间扩容</p>
              </div>
              <div
                @click.stop="handleDh"
                class="flex ac hover-pop-box_new_item"
              >
                <img :src="`编组38.png` | fullImageUrl" />
                <p>算力兑换</p>
              </div>

              <div
                class="flex ac hover-pop-box_new_item"
                @click.stop="handleReset"
              >
                <img :src="`编组39.png` | fullImageUrl" />
                <p>修改密码</p>
              </div>

              <div
                @click.stop="handleJump(6, '/consum')"
                class="flex ac hover-pop-box_new_item"
              >
                <img :src="`编组40.png` | fullImageUrl" />
                <p>算力使用记录</p>
              </div>
              <div @click="handleOut" class="flex ac hover-pop-box_new_item">
                <img :src="`编组41.png` | fullImageUrl" />
                <p>
                  {{ is_tourist == 1 ? "立即登录" : "切换账号" }}
                </p>
              </div>
            </div>
          </template>
          <template slot="reference">
            <div class="avatar-box cr">
              <img :src="avatar" alt="" />
            </div>
          </template>
        </el-popover>
      </div>
    </div>
    <div class="all-info-box flex jb bbox">
      <div class="left-nav-box cr" :style="{ borderRightColor: theme.layout6 }">
        <div
          class="flex ac every-nav"
          @click="handleJump(0, '/')"
          :style="{
            color: navState == 0 ? theme.layout4 : theme.layout2,
            backgroundColor: navState == 0 ? theme.layout5 : '',
          }"
        >
          <img v-if="navState == 0" :src="theme.layoutIcon1" alt="" />
          <img v-else :src="theme.layoutIcon2" alt="" />
          <p class="pp1">首页</p>
        </div>
        <div class="pp2" :style="{ color: theme.layout3 }">功能</div>

        <!-- <div
          class="flex ac every-nav"
          @click="handleJump(11, '/helper/index')"
          v-if="yyShow"
          :style="{
            color: navState == 11 ? theme.layout4 : theme.layout2,
            backgroundColor: navState == 11 ? theme.layout5 : '',
          }"
        >
          <img v-if="navState == 11" :src="theme.layoutIcon25" alt="" />
          <img v-else :src="theme.layoutIcon26" alt="" />
          <p class="pp1">超级助手</p>
        </div> -->

        <div
          class="flex ac every-nav"
          @click="handleJump(1, '/create')"
          :style="{
            color: navState == 1 ? theme.layout4 : theme.layout2,
            backgroundColor: navState == 1 ? theme.layout5 : '',
          }"
        >
          <img v-if="navState == 1" :src="theme.layoutIcon3" alt="" />
          <img v-else :src="theme.layoutIcon4" alt="" />
          <p class="pp1">视频创作</p>
        </div>
        <div
          class="flex ac every-nav"
          @click="handleJump(2, '/profile')"
          :style="{
            color: navState == 2 ? theme.layout4 : theme.layout2,
            backgroundColor: navState == 2 ? theme.layout5 : '',
          }"
        >
          <img v-if="navState == 2" :src="theme.layoutIcon5" alt="" />
          <img v-else :src="theme.layoutIcon6" alt="" />
          <p class="pp1">数字形象</p>
        </div>
        <!--        <div class="flex ac every-nav" :class="navState==7?'actvie':''" @click="handleJump(7,'gProfile')">-->
        <!--          <img v-if="navState==7" src="../assets/pcImages/Left_Icon_Home2@2x.png" alt="">-->
        <!--          <img v-else src="../assets/pcImages/Left_Icon_Home1@2x.png" alt="">-->
        <!--          <p class="pp1">公共形象</p>-->
        <!--        </div>-->
        <div
          class="flex ac every-nav"
          @click="handleJump(3, '/clone')"
          :style="{
            color: navState == 3 ? theme.layout4 : theme.layout2,
            backgroundColor: navState == 3 ? theme.layout5 : '',
          }"
        >
          <img v-if="navState == 3" :src="theme.layoutIcon7" alt="" />
          <img v-else :src="theme.layoutIcon8" alt="" />
          <p class="pp1">声音克隆</p>
        </div>
        <!-- <div
          class="flex ac every-nav"
          :style="{
            color: navState == 4 ? theme.layout4 : theme.layout2,
            backgroundColor: navState == 4 ? theme.layout5 : '',
          }"
          @click="handleJump(4, '/multiples')"
        >
          <img v-if="navState == 4" :src="theme.layoutIcon17" alt="" />
          <img v-else :src="theme.layoutIcon18" alt="" />
          <p class="pp1">批量场景</p>
        </div> -->

        <!--        <div class="flex ac every-nav"-->
        <!--             :style="{ color: navState==7 ? theme.layout4 : theme.layout2, backgroundColor: navState==7 ? theme.layout5 : ''}"-->
        <!--             @click="handleJump(7,'/pet')">-->
        <!--          <img v-if="navState==7" :src="theme.layoutIcon19" alt="">-->
        <!--          <img v-else :src="theme.layoutIcon20" alt="">-->
        <!--          <p class="pp1">宠物视频</p>-->
        <!--        </div>-->

        <div
          class="flex ac every-nav"
          :style="{
            color: navState == 10 ? theme.layout4 : theme.layout2,
            backgroundColor: navState == 10 ? theme.layout5 : '',
          }"
          @click="handleJump(10, '/explosiveAnalysis')"
        >
          <img v-if="navState == 10" :src="theme.layoutIcon23" alt="" />
          <img v-else :src="theme.layoutIcon24" alt="" />
          <p class="pp1">精雕细琢</p>
        </div>

        <div class="pp2" :style="{ color: theme.layout3 }">视频</div>
        <div
          class="flex ac every-nav"
          @click="handleJump(5, '/works')"
          :style="{
            color: navState == 5 ? theme.layout4 : theme.layout2,
            backgroundColor: navState == 5 ? theme.layout5 : '',
          }"
        >
          <img v-if="navState == 5" :src="theme.layoutIcon9" alt="" />
          <img v-else :src="theme.layoutIcon10" alt="" />
          <p class="pp1">我的作品</p>
        </div>

        <div class="pp2" :style="{ color: theme.layout3 }">其他</div>

        <div
          class="flex ac every-nav"
          @click="handleJump(6, '/consum')"
          :style="{
            color: navState == 6 ? theme.layout4 : theme.layout2,
            backgroundColor: navState == 6 ? theme.layout5 : '',
          }"
        >
          <img v-if="navState == 6" :src="theme.layoutIcon11" alt="" />
          <img v-else :src="theme.layoutIcon12" alt="" />
          <p class="pp1">消费中心</p>
        </div>
      </div>
      <div class="right-info-box">
        <router-view></router-view>
      </div>
    </div>

    <el-dialog title="修改密码" :visible.sync="dialogVisible" width="30%">
      <div class="password-pop">
        <!-- <div class="line"></div> -->
        <p>
          <i
            class="el-icon-warning"
            style="color: #ff7d00; margin-right: 5px"
          ></i
          >重置密码成功后将退出本次登录重新登录
        </p>
        <el-form
          style="margin: 20px 0"
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          label-width="100px"
          class="ruleForm-box"
        >
          <el-form-item label="新密码" prop="password">
            <el-input
              v-model="ruleForm.password"
              placeholder="请输入至少6位，数字+字母组合"
              type="password"
              autocomplete="off"
              show-password
            />
          </el-form-item>
          <el-form-item label="确认新密码" prop="confirm">
            <el-input
              v-model="ruleForm.confirm"
              placeholder="请输入至少6位，数字+字母组合"
              type="password"
              autocomplete="off"
              show-password
            />
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')"
              >提交</el-button
            >
          </el-form-item> -->
        </el-form>
        <!-- <div class="line"></div> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <div style="margin-top: -10px">
          <el-button type="info" @click="dialogVisible = false"
            >取 消</el-button
          >
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确 定</el-button
          >
        </div>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible2" width="100px" top="30vh">
      <div class="sl-box">
        <div @click="dialogVisible2 = false">
          <img :src="`编组71.png` | fullImageUrl" />
        </div>
        <div class="main-box">
          <div>
            <el-input
              class="input-box"
              v-model="code"
              placeholder="请输入算力兑换码"
            />
          </div>
          <div class="btn-box" @click="submitDh">立即兑换</div>
        </div>
        <!-- <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible2 = false">取 消</el-button>
          <el-button type="primary" @click="submitDh">确 定</el-button>
        </span> -->
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  changePwd,
  credits,
  space,
  cdkey,
  site,
  notice,
  spaceExpand,
  delVideo,
  creditsRule,
} from "../api/user";
import { mapActions } from "vuex";
import _ from "lodash";
import { throttle } from "../../utils";

export default {
  name: "",
  watch: {
    $route(to, from) {
      // console.log('路由变化了');
      // console.log('当前页面路由：' + to.path);
      // console.log('上一个路由：' + from.path);
      this.checkNav(to.path);
    },
  },
  computed: {
    theme() {
      return this.$store.getters.getTheme;
    },
    points() {
      return this.$store.getters.getPoints;
    },
    yyShow() {
      const currentDomain = window.location.hostname;
      // 允许显示的域名列表
      const allowedDomains = [
        "koubo123.com",
        "qh.koubo123.com",
        "yanyu.qhagent.cn",
        "qhagent.cn",
      ];
      return allowedDomains.includes(currentDomain);
      // return true;
    },
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else {
        if (this.ruleForm.password !== "") {
          this.$refs.ruleForm.validateField("confirm");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入新密码"));
      } else if (value !== this.ruleForm.password) {
        callback(new Error("两次输入新密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      navState: 0,
      dialogVisible: false,
      dialogVisible2: false,
      dialogVisible3: false,
      popoverVisible: null,
      popoverVisible2: null,
      popoverVisible3: null,
      popoverVisible4: null,
      popoverVisible5: null,
      newpopoverVisible1: null,

      avatar: "",
      expire_time: "",
      is_tourist: 1,
      username: "",
      percent: 0,
      used: 0,
      total: 0,
      can_expand: 0,
      total_format: null,
      code: "",
      ruleForm: {
        // old_pass: '',
        password: "",
        confirm: "",
      },
      head_logo: "",
      rules: {
        old_pass: [
          { required: true, message: "请填写原密码", trigger: "change" },
        ],
        password: [{ validator: validatePass, trigger: "blur" }],
        confirm: [{ validator: validatePass2, trigger: "blur" }],
      },
      keywords: "",
      description: "",
      title: "",
      create_time: "",
      content: "",
      jfContent: "",
      noticeList: [],
      icp: "",
      gabeian: "",
      copyright: "",
      cert: "",
      safety_cert: "",
      site_title: "",
      qrcode: "",
      activeNoticeIndex: null, //通知收起，展开
    };
  },
  created() {
    this.getCredits();
    this.getSpace();
    this.getSite();
    this.getNotice();
    this.getCreditsRule();
    if (this.$route.path.indexOf("home") > -1) {
      this.navState = 0;
    }
    if (this.$route.path.indexOf("create") > -1) {
      this.navState = 1;
    }
    if (this.$route.path.indexOf("profile") > -1) {
      this.navState = 2;
    }
    if (this.$route.path.indexOf("clone") > -1) {
      this.navState = 3;
    }
    if (this.$route.path.indexOf("works") > -1) {
      this.navState = 5;
    }
    if (this.$route.path.indexOf("consum") > -1) {
      this.navState = 6;
    }
    if (this.$route.path.indexOf("pet") > -1) {
      this.navState = 9;
    }
    if (this.$route.path.indexOf("use") > -1) {
      this.navState = 8;
    }
    if (this.$route.path.indexOf("multiples") > -1) {
      this.navState = 4;
    }
    if (this.$route.path.indexOf("establishPet") > -1) {
      this.navState = null;
    }
    if (this.$route.path.indexOf("store") > -1) {
      this.navState = 9;
    }
    if (this.$route.path.indexOf("explosive") > -1) {
      this.navState = 10;
    }
    if (this.$route.path.indexOf("helper") > -1) {
      this.navState = 11;
    }
    if (this.$route.path.indexOf("/material") > -1) {
      this.navState = 12;
    }
    if (this.$route.path.indexOf("/employee") > -1) {
      this.navState = 13;
    }
    this.updatePoints();
    // if (localStorage.getItem('navId')) {
    //   this.navState = localStorage.getItem('navId')
    // } else {
    //   this.navState = 0
    // }
  },
  methods: {
    ...mapActions(["updatePoints"]),
    formatProgress(percentage) {
      // 这里可以返回你想要的格式，例如保留两位小数
      return `${percentage.toFixed(2)}%`;
    },
    getCredits() {
      credits({}).then((res) => {
        // console.log("==========", res);
        this.username = res.data.username;
        this.avatar = res.data.avatar;
        this.expire_time = res.data.expire_time;
        this.is_tourist = res.data.is_tourist;
      });
    },
    getNotice() {
      notice().then((res) => {
        this.noticeList = res.data;
        if (res.data[0] && res.data[0].id) {
          this.getNoticeDetails(res.data[0].id);
        }
      });
    },
    getCreditsRule() {
      creditsRule().then((res) => {
        this.jfContent = this.changeText(res.data.content);
      });
    },

    showNotice(item, index) {
      if (this.activeNoticeIndex === index) {
        this.activeNoticeIndex = null;
      } else {
        this.activeNoticeIndex = index;
      }
      this.getNoticeDetails(item.id);
    },
    getNoticeDetails(id) {
      notice({
        id: id,
      }).then((res) => {
        this.title = res.data.title;
        this.create_time = res.data.create_time;
        this.content = this.changeText(res.data.content);
      });
    },
    changeText(val) {
      const imageRegex = /<img((?![^>]*?style)[^>]*)>/gi;
      const replacedText = val.replace(imageRegex, (match) => {
        return `<img ${match.slice(0, -1)} style="width: 100%;">`;
      });
      return replacedText;
    },
    // 获取配置
    getSite() {
      site().then((res) => {
        this.head_logo = res.data.head_logo ? res.data.head_logo : require("../assets/ccc/编组4.png")
        // this.head_logo = require("../assets/ccc/编组4.png")
        this.keywords = res.data.seo_keyword;
        this.description = res.data.seo_desc;

        this.site_title = res.data.site_title
          ? res.data.site_title
          : "AI引爆获客";
        this.icp = res.data.icp;
        this.gabeian = res.data.gabeian;
        this.copyright = res.data.copyright;
        this.cert = res.data.cert;
        this.safety_cert = res.data.safety_cert;

        this.qrcode = res.data.qrcode
          ? res.data.qrcode
          : require("../assets/pcImages/qcCode.png");

        // this.avatar = res.data.avatar ? res.data.avatar :'https://oss.xingchaoyiqing.com/html/base/images/home/avatar.png'
      });
    },
    getSpace() {
      space({}).then((res) => {
        this.used = res.data.used;
        this.total = res.data.total;
        // this.percent = (res.data.used / res.data.total).toFixed(2) * 100
        this.percent = parseFloat(
          ((res.data.used / res.data.total) * 100).toFixed(2)
        );
        this.can_expand = res.data.can_expand;
        // G（单位）
        this.total_format = res.data.total_format;
      });
    },
    handleShowMore() {
      this.$router.push("/moreCredits");
    },
    handleJump(val, path) {
      // if(val==99){
      //   this.$message('陆续上线，敬请期待！');
      //   return false
      // }
      this.popoverVisible = false;
      this.popoverVisible2 = false;
      this.popoverVisible3 = false;
      this.popoverVisible4 = false;
      this.navState = val;
      localStorage.setItem("navId", val);
      this.$router.push(path);
    },
    handleJump2() {
      if (this.$route.path != "/home") {
        localStorage.setItem("navId", 0);
        this.$router.push("/");
      }
    },
    handleShow() {
      if (this.noticeList.length <= 0) {
        this.$message.error("暂无公告！");
      } else {
        this.dialogVisible3 = true;
      }
    },
    // 扩容
    handleKr() {
      if (this.can_expand == 0) {
        this.$message.error("您已扩容至上限！");
        return false;
      }
      const that = this;
      that
        .$confirm(
          "此操作将使用5000算力兑换5G扩容空间, 是否继续?",
          "是否扩容空间？",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
        .then(() => {
          spaceExpand({})
            .then((res) => {
              if (res) {
                that.$message.success("兑换成功");
              }
              that.getSpace();
            })
            .catch((error) => {
              that.$message.error(error.msg);
            });
        })
        .catch(() => {
          that.$message({
            type: "info",
            message: "已取消扩容",
          });
        });
    },
    handleDh() {
      if (this.is_tourist == 1) {
        this.$router.push({
          path: "/login",
          query: {
            state: 2,
          },
        });
      } else {
        this.dialogVisible2 = true;
      }
    },
    handleReset() {
      this.dialogVisible = true;
    },
    submitDh() {
      cdkey({ code: this.code }).then((res) => {
        this.$message.success("您已成功兑换" + res.data.credits + "算力");
        this.code = "";
        this.getCredits();
        this.dialogVisible2 = false;
      });
    },
    // 退出登录
    handleOut() {
      this.popoverVisible = false;
      this.popoverVisible2 = false;
      window.localStorage.removeItem("xcToken");
      this.$router.replace({ path: "/login" });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          changePwd(this.ruleForm)
            .then((res) => {
              // this.$message.success(res.msg)
              if (res.msg) {
                this.$message.success(res.msg);
              } else {
                this.$message.success("操作成功！");
              }
              window.localStorage.removeItem("xcToken");
              // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
              if (window.location.hash) {
                const url = window.location.hash.split("#")[1];
                // window.localStorage.setItem('redirectUrl', url)
                this.$router.push({
                  path: "/login",
                  query: {
                    redirectUrl: url,
                  },
                });
              }
            })
            .catch((error) => {
              this.$message.error(error.msg);
            });
        } else {
          return false;
        }
      });
    },
    // 根据路由判断navState
    checkNav(val) {
      if (val.indexOf("/home") > -1) {
        this.navState = 0;
      }
      if (val.indexOf("/create") > -1) {
        this.navState = 1;
      }
      if (val.indexOf("/profile") > -1) {
        this.navState = 2;
      }
      if (val.indexOf("/gProfile") > -1) {
        this.navState = 7;
      }
      if (val.indexOf("/clone") > -1) {
        this.navState = 3;
      }
      if (val.indexOf("/works") > -1) {
        this.navState = 5;
      }
      if (val.indexOf("/consum") > -1) {
        this.navState = 6;
      }
      if (val.indexOf("/pet") > -1) {
        this.navState = 9;
      }
      if (val.indexOf("/store") > -1) {
        this.navState = 9;
      }
      if (val.indexOf("/explosive") > -1) {
        this.navState = 10;
      }
      if (val.indexOf("/helper") > -1) {
        this.navState = 11;
      }
      if (val.indexOf("/material") > -1) {
        this.navState = 12;
      }
      if (val.indexOf("/employee") > -1) {
        this.navState = 13;
      }
      localStorage.setItem("navId", this.navState);
    },
    changeTitle() {
      site().then((res) => {
        const title = res.data.title;
        if (title) {
          document.title = title;
        }
      });
    },
  },
  /**加载完组件时执行(加载完成之后执行)*/
  mounted() {
    this.changeTitle();
  },
  metaInfo() {
    return {
      meta: [
        { name: "keywords", content: this.keywords },
        { name: "description", content: this.description },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.newtitle {
  font-weight: 500;
  font-size: 13px;
  color: #bcae8b;
  line-height: 19px;
}

.newboder {
  margin-left: 10px;
  padding: 7px 16px;
  background: #0d1116;
  border-radius: 16px;
  border: 1px solid rgba(247, 210, 116, 0.25);
}

.all-buju {
  width: 100vw;
  height: 100vh;
  background: #f3f4fb;
  overflow: hidden;
  box-sizing: border-box;

  .all-head-box {
    width: 100vw;
    height: 56px;
    padding: 0 50px;
    /*background: #0D1027;*/
    /*box-shadow: 0px 1px 0px 0px rgba(250,250,250,0.1);*/
    // border-bottom: 1px solid;//顶部下边框

    img {
      width: 39px;
      height: 39px;
      /*width: 40px;*/
      /*height: 40px;*/
      object-fit: cover;
    }
  }

  .all-info-box {
    width: 100vw;
    height: calc(100vh - 56px);

    .left-nav-box {
      position: relative;
      padding: 16px !important;
      height: 100%;
      width: 200px;
      /*color: #FAFAFA;*/
      overflow-y: scroll;
      overflow-x: hidden;
      // border-right: 1px solid;//侧边栏右边框
      //box-shadow: 1px 0px 0px 0px rgba(250, 250, 250, 0.15);//侧边栏右边框

      /*background: #0D1027;*/

      .every-nav {
        box-sizing: border-box;
        padding: 0 10px;
        font-size: 14px;
        width: 176px;
        height: 40px;
        border-radius: 8px;
        color: #fafafaaa;

        .pp1 {
          margin-left: 13px;
        }

        img {
          width: 22px;
          height: 22px;
        }
      }

      .actvie {
        background-color: #6c14ff !important;
        color: #ffffff !important;
      }

      .pp2 {
        height: 20px;
        font-size: 12px;
        color: #5b647a;
        display: block;
        margin: 16px 0 4px 10px;
      }

      .beian-box {
        position: absolute;
        bottom: 10px;
      }
    }

    .right-info-box {
      width: 1720px;
      height: calc(100vh - 95px - 50px);
      color: #ffffff;
      border-right: 1px rgba(250, 250, 250, 0.1) solid;
    }
  }
}

.hover-pop-box_new_item {
  p {
    font-weight: 400;
    font-size: 13px;
    color: #fff6de;
  }

  img {
    margin-right: 10px;
    width: 16px;
    height: 16px;
  }
}

.hover-pop-box_new {
  padding: 0 12px;
  min-width: 222px;
  // width: 100%;
  .pop-userinfo {
    display: flex;
    flex-direction: row;
    align-items: center;

    img {
      border-radius: 50%;
      width: 32px;
      height: 32px;
      background: #1c1c1f;
      border: 1px solid rgba(247, 210, 116, 0.2);
    }

    .username {
      margin-left: 10px;
      font-weight: 500;
      font-size: 15px;
      color: #fff6de;
    }
  }
  .shiyongkongjian {
    margin-top: 8px;
    margin-bottom: 6px;
  }
  .used {
    font-weight: 400;
    font-size: 13px;
    color: #f7d274;
  }
}

.popover-box {
  color: #fafafa;
  font-size: 14px;

  .hover-pop-box {
    padding: 0 30px;

    .pop-userinfo {
    }

    .top-pop-box {
      border-bottom: 1px #999999 solid;
    }

    .btn1,
    .btn2 {
      width: 120px;
      height: 36px;
      background: #ffffff;
      border-radius: 4px;

      font-weight: 600;
      font-size: 14px;
      color: #666666;
      line-height: 36px;
      text-align: center;
    }

    .btn2 {
      background: #6c14ff;
      color: #ffffff;
    }
  }

  .vip-box {
    // margin: 0 16px;
    /*width: 120px;*/
    // padding: 0 12px;
    font-weight: 500;
    font-size: 13px;
    line-height: 18px;
    text-align: left;
    font-style: normal;
    background: linear-gradient(44.70008775128211deg, #f7d274 0%, #f5dfb5 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    display: inline-block;
  }

  .pc-h5 {
    width: 28px;
    height: 28px;
    margin: 0 16px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .er-wei-ma {
    width: 14px;
    height: 14px;
  }

  .notice-icon {
    // width: 16px;
    // height: 16px;

    img {
      width: 16px;
      height: 16px;
    }
  }

  .avatar-box {
    margin-left: 24px;
    width: 36px;
    height: 36px;
    object-fit: cover;
    /*border: 1px solid rgba(1, 251, 245, 1);*/
    border-radius: 50%;

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
}

.icon-point-img {
  width: 18px !important;
  height: 18px !important;
  margin-right: 5px;
}
.icon-point-img-txt {
  font-weight: 500;
  font-size: 13px;
  color: #f7d274;
}

.btn1,
.btn2 {
  width: 120px;
  height: 36px;
  background: #f1ebeb;
  border-radius: 4px;

  font-weight: 600;
  font-size: 14px;
  color: #666666;
  line-height: 36px;
  text-align: center;
}

.btn2 {
  background: #6c14ff;
  color: #ffffff;
}

.ykt-text {
  font-weight: 500;
  font-size: 13px;
  color: #191919;
  line-height: 18px;
  text-align: left;
  font-style: normal;
  background: linear-gradient(44.70008775128211deg, #f7d274 0%, #f5dfb5 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  display: inline-block;
  margin-top: 10px;
}

.er-wei-box {
  margin-top: -10px;
  p {
    font-weight: 500;
    font-size: 14px;
    color: #e9dec2;
    text-align: center;
  }

  img {
    width: 120px;
    height: 120px;
    display: block;
    margin: 0 auto;
  }
}

.notice-box {
  background: #1f1f1f;
  width: 100%;

  p {
    margin: 0;
  }

  max-height: 65vh;

  .notice-left::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }

  .notice-left {
    // background: #eff7fd;
    // width: 320px;
    max-height: 65vh;
    width: 100%;
    overflow: scroll;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    .every-notice1 {
      font-weight: 600;
      font-size: 16px;
      color: #f7d274;
      padding-left: 16px;
      // padding: 12px 12px 0 12px;
      // border-bottom: 1px solid rgba(151, 151, 151, 0.3);
    }

    .every-notice {
      width: 95%;
      // margin: 0 auto;
      padding: 6px 0;
      box-sizing: border-box;
      // background: red;
      .notice-item {
        margin: 0 16px;
        padding: 12px;
        width: 100%;
        // height: 207px;
        background: #262626;
        border-radius: 8px;

        .notice-item-title {
          font-weight: 500;
          font-size: 14px;
          color: #ffffff;
          padding-bottom: 10px;
        }

        .notice-item-cont {
          font-weight: 400;
          font-size: 12px;
          color: rgba(255, 255, 255, 0.7);
          line-height: 20px;
        }

        .item-bottom {
          border-top: 1px solid rgba(151, 151, 151, 0.3);

          .item-bottom-left {
            padding-top: 10px;
            font-weight: 400;
            font-size: 12px;
            color: rgba(255, 255, 255, 0.4);
          }

          .item-bottom-rigth {
            padding-top: 10px;
            font-weight: 400;
            font-size: 12px;
            color: rgba(255, 255, 255, 0.9);
            padding-right: 15px;
          }
        }
      }

      .new_notice_p {
        font-weight: 500;
        font-size: 14px;
        color: #ffffff;
      }
    }
  }

  .notice-right::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }

  .notice-right {
    padding: 40px;
    height: 65vh;
    overflow: scroll;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
  }
}

.sl-box {
  img {
    position: absolute;
    top: -80px;
    left: -1px;
    width: 320px;
    height: 261px;
    z-index: 888;
  }

  .main-box {
    position: absolute;
    z-index: 999;
    top: 40%;
    // bottom: 0;
    .btn-box {
      margin-top: 24px;
      font-weight: 500;
      font-size: 16px;
      color: #191919;
      width: 280px;
      height: 42px;
      text-align: center;
      line-height: 42px;
      background: linear-gradient(135deg, #f7d274 0%, #f5dfb5 100%);
      border-radius: 24px;
    }
  }
}

.password-pop {
  margin-top: -30px;

  p {
    font-weight: 400;
    font-size: 14px;
    color: #ff7d00;
  }

  .line {
    border: 1px solid #e5e6e8;
    opacity: 0.1;
  }
}
</style>
<style>
.left-nav-box::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

.left-nav-box {
  width: 100vw;
  height: 100vh;
  background-size: 100% 100%;
  overflow: hidden;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
}

.left-nav-box::-webkit-scrollbar {
  width: 0; /* Chrome, Safari 和其他Webkit浏览器 */
  height: 0;
}

.notic-dailog-box .el-dialog__header {
  display: none;
}

.notic-dailog-box .el-dialog__body {
  padding: 0;
}

.newboder.el-divider {
  background-color: #f7d274;
}

.input-box .el-input__inner {
  /* border: none !important; */
  /* color: #fff !important;
    padding: 0 15px !important;
    height: 42px !important;
    line-height: 42px !important; */
}

.el-divider {
  background-color: rgba(247, 210, 116, 0.25);
}
/* .progress-box .el-progress {
  display: flex;
  flex: row;
  justify-content: space-between;
  align-items: center;
  width: 180px; */
/* color: red; */
/* } */
/* .progress-box .el-progress__text {
  width: 40px; */
/* white-space: nowrap; */
/* font-weight: 400 !important;
  font-size: 12px !important;
  color: rgba(255, 246, 222, 0.8) !important;
  line-height: 18px !important;
} */
.layout-divider-box .el-divider {
  background-color: rgba(247, 210, 116, 0.25);
}
</style>



// WEBPACK FOOTER //
// src/components/layout.vue